import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import css from '../BookingDetailsForm/BookingDetailsForm.module.css';
import { AlTextField } from '../../../common/components/AlTextField';
import { CUSTOMER_TYPE_COMPANY } from '../../../constants';
import ErrorOutlineRounded from '@mui/icons-material/ErrorOutlineRounded';
import { useDictionary } from '../../../common/contexts/DictionaryContext';

const InvoiceTo = ({ booking, onNumberChange, onChange, bookingError = () => false, touchBooking = () => {} }) => {
    const { t } = useTranslation();
    const { customerTypes: invoiceToOptions = [] } = useDictionary();

    return (
        <Box sx={{ mb: 3 }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: { xs: 'flex-start', sm: 'center' },
                }}
            >
                <Typography variant="h7" sx={{ pr: 2, mb: { xs: 1, sm: 0 } }} noWrap>
                    {t('invoice-to-label')}
                </Typography>

                <RadioGroup
                    name="user.customerTypeId"
                    value={booking.user.customerTypeId}
                    onChange={onNumberChange}
                    row
                >
                    {invoiceToOptions
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((item) => (
                            <FormControlLabel
                                key={item.id}
                                value={item.id}
                                control={<Radio />}
                                label={<Typography>{t(`customerType.${item.name}`)}</Typography>}
                            />
                        ))}
                </RadioGroup>
            </Box>

            {booking.user.customerTypeId === CUSTOMER_TYPE_COMPANY && (
                <>
                    <Box sx={{ mt: 1 }}>
                        <div className={css.item}>
                            <AlTextField
                                fullWidth
                                autoFocus
                                name="user.companyName"
                                onChange={onChange}
                                onBlur={touchBooking}
                                error={bookingError('user.companyName')}
                                value={booking.user.companyName || ''}
                                placeholder={t('placeholder.companyNameLegalForm')}
                                alTooltip={t('tooltip.user.companyName')}
                                required
                            />
                        </div>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: { xs: 0, sm: 1 } }}>
                        <ErrorOutlineRounded />
                        <Typography
                            variant="caption"
                            sx={{
                                display: 'block',
                                lineHeight: 1.4,
                            }}
                        >
                            {t('invoice-correction-info')}
                        </Typography>
                    </Box>
                </>
            )}
        </Box>
    );
};

export { InvoiceTo };
